export enum CompanyTeamNotesBlock {
  Root = 'CompanyTeamNotes',
}

export enum CompanyTeamNotesElement {
  Chat = 'chat',
}
